import { render } from "./BannerArea.vue?vue&type=template&id=356dba90"
import script from "./BannerArea.vue?vue&type=script&lang=js"
export * from "./BannerArea.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__